const esquemaCampos = {
    cliente: { valor: null, error: '' },
    producto: { valor: '', error: '' },
    modulo:{valor:'', error: ''},
    descripcion: { valor: '', error: '' },
    responsable: { valor: null, error: '' },
    tipoServicio: { valor: '', error: '' },
    tipoAtencion: { valor: '', error: '' },
    prioridad: { valor: 0, error: '' },
    fechaLimite: { valor: new Date(), error: '' }
 };

 const esquemaValidacion = {
    cliente: {
       requerido: true,
       validador: {
          regla: valor => {
             return valor !== '';
          }
       }
    },
    producto: {
       requerido: true,
       validador: {
          regla: valor => {
             return valor.value !== '';
          }
       }
    },
    modulo: {
       requerido: false
    },
    descripcion: {
       requerido: true,
       validador: {
          regla: valor => {
             return valor !== '';
          },
          error: 'El campo descripcion no puede estar vacio.'
       }
    },
    responsable: {
       requerido: true,
       validador: {
          regla: valor => {
             return valor !== null;
          },
          error: 'El campo responsable no puede estar vacio.'
       }
    },
    tipoServicio: {
       requerido: false,
       validador: {
          regla: valor => {
             return valor !== '';
          }
       }
    },
    tipoAtencion: {
       requerido: true,
       validador: {
          regla: valor => {
             return valor !== '';
          }
       }
    },
    prioridad: {
       requerido: false,
       validador: {
          cast: valor => {
             return parseInt(valor);
          }
       }
    },
    fechaLimite: {
       requerido: false
    }
 };

 function oEstadosActividad(
    codActividad,
    denominacion,
    responsable,
    fecha,
    horaIni,
    horaFin,
    moduloAtencion,
    descripcion,
    observaciones
 ) {
    this.actividad = codActividad;
    this.denominacion = denominacion !== null && denominacion !== undefined ? denominacion : '';
    this.fecha = fecha !== null && fecha !== undefined ? fecha : null;
    this.horaIni = horaIni !== null && horaIni !== undefined ? horaIni : null;
    this.horaFin = horaFin !== null && horaFin !== undefined ? horaFin : null;
    this.moduloAtencion = moduloAtencion || null;
    this.descripcion = descripcion !== null && descripcion !== undefined ? descripcion : '';
    this.observaciones = observaciones !== null && observaciones !== undefined ? observaciones : '';
    this.responsable = responsable;
 }

 module.exports = {
   oEstadosActividad,
   esquemaCampos,
   esquemaValidacion
}